import {USER_ROOT_API_URL} from "../../../../config/settings.js"

export const GET_COMMUNITY_LIST = USER_ROOT_API_URL +  "/get_all_communities"
export const GET_COMMUNITY_DETAILS = USER_ROOT_API_URL +  "/get_community"
export const GET_COMMUNITY_POSTS = USER_ROOT_API_URL +  "/get_community_posts"